var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-alert',{attrs:{"color":"#E7F7F8","icon":"fas fa-info-circle"}},[_vm._v(" "+_vm._s(_vm.emptyTypeMessage)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }